<!--Rest pages (Elements)-->
<div class="row_container ptitle">
  <div class="col-12">
    <h2 class="pb-4"><strong>{{elementResultTitle}}</strong></h2>
  </div>
</div>

<ng-container *ngIf="printData.drawers">
  <div class="row_container rootelem" *ngFor="let drawer of printData.drawers">
    <div class="col-12" *ngIf="drawer?.addedElements?.length > 0">
      <ng-container *ngFor="let addedElement of drawer.addedElements">
        <div class="elem" *ngIf="!addedElement.noActiveProductsInThisElement">
          <div class="addedElement_container">
            <div>
              <span class="img_container">
                <img [src]="uploadsImageBaseUrl + addedElement.iconPath">
              </span>
              <span class="addedElement_name">
                {{addedElement.name}}
              </span>
            </div>

            <div class="badge current_after_mpg element_mpg" [class.mw_90]="isExistingBuildingCal">
              <div *ngIf="selectedDataSet != dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="addedElementMpg">
                {{ addedElement.mpg | number:'.3-3' | dynamicDecimal: false}}
              </div>
              <div *ngIf="selectedDataSet == dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="addedElementMpg">
                {{ addedElement.mpg | number:'.3-3' | dynamicDecimal: true}}
              </div>
              <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)" data-test="addedElementMpgAfter">
                {{ addedElement.mpgAfter | number:'.3-3' | dynamicDecimal: true }}
              </div>
            </div>
          </div>

          <hr>

          <!-- Nmd element comment -->
          <span *ngIf="addedElement.comment" class="comment_container">
            {{addedElement.comment.value}}
          </span>

          <div *ngIf="addedElement.nmdElements" class="nmdElements">
            <ng-container *ngFor="let nmdElement of addedElement.nmdElements">
              <div class="nmdElement" *ngIf="!nmdElement.noActiveProductsInThisElement">
                <div *ngIf="!isExistingBuildingCal" class="nmdElement_name">{{nmdElement.name}}</div>
                <div *ngIf="isExistingBuildingCal" class="nmdElement_name ">
                  {{nmdElement.name}}
                  <div class="header_div">
                    <small>{{'COMPONENTS.PRODUCT.CURRENT' | translate}}</small>
                    <small>{{'COMPONENTS.PRODUCT.CHANGE' | translate}}</small>
                    <small>{{'COMPONENTS.PRODUCT.AFTER' | translate}}</small>
                  </div>
                </div>

                <div *ngIf="nmdElement.products">
                  <ng-container *ngFor="let product of nmdElement.products">
                    <div *ngIf="product.productStatusId === nmdProductStatusEnum.Active">
                      <table class="table table-borderless">
                        <thead>
                          <tr>
                            <td class="category_container">
                              <span *ngIf="product.validationCategory" class="grey">
                                Cat. {{product.validationCategory === 4 ? '3a' : (product.validationCategory || 0)}}
                              </span>
                            </td>
                            <td>
                                {{product.name}}  
                                <span *ngIf="product.isNlsfbElementMismatch">
                                    <img alt="" class="m-auto" height="20" width="30" src="../../../../assets/img/broken-link.svg" placement="top" />
                                </span>
                                <span class="product_type_ele"
                                      *ngIf="product.typeId === 2">(Hergebruikt)</span>
                            </td>
                            <td class="profileSet_container" *ngIf="product?.profileSetInputs?.length > 0">
                              <ng-container *ngFor="let profileSet of product.profileSetInputs">
                                <div class="psets" *ngIf="profileSet.isScalable">
                                  <span *ngIf="profileSet.dimensionOne" class="pl-2">
                                    <span class="lab">{{profileSet.dimensionOne.quantityName}}</span>
                                    <span class="fld">
                                      {{profileSet.dimensionOne?.value}} <span [innerHTML]="profileSet.dimensionOne?.unit"></span>
                                    </span>
                                  </span>
                                  <span *ngIf="profileSet.dimensionTwo" class="pl-2">
                                    <span class="lab">{{profileSet.dimensionTwo?.quantityName}}</span>
                                    <span class="fld">
                                      {{profileSet.dimensionTwo?.value}} <span [innerHTML]="profileSet.dimensionTwo?.unit"></span>
                                    </span>
                                  </span>
                                </div>
                              </ng-container>
                            </td>
                            <!-- Current Amount -->
                            <td class="product_amountPerUnit">
                              <div>
                                {{product.amountPerUnit * addedElement.amount | number:'.0-2'}}
                                <span *ngIf="!isExistingBuildingCal" [innerHTML]="product.unit"></span>
                              </div>
                            </td>

                            <ng-container *ngIf="isExistingBuildingCal">
                              <!-- Change Amount -->
                              <td class="product_change_amount">
                                <div>
                                  {{product.changeAmount | number:'.0-2'}}
                                </div>
                              </td>
                              <!-- After amount -->
                              <td class="product_after_amount">
                                <div>
                                  {{product.amountPerUnit + (product.changeAmount) | number:'.0-2'}}
                                  <span [innerHTML]="product.unit"></span>
                                </div>
                              </td>
                            </ng-container>

                            <td class="mpg_badge_container" [class.mw_100]="isExistingBuildingCal">
                              <div class="badge current_after_mpg product_mpg">
                                  <div *ngIf="selectedDataSet != dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="productMpg">
                                      {{selectedDataSet == dataSetSetting.A1A2 && !hasA1Data(product) ? '-' : product?.mpg || 0 | number:'.3-3' | dynamicDecimal: false}}
                                  </div>
                                  <div *ngIf="selectedDataSet == dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="productMpg">
                                      {{selectedDataSet == dataSetSetting.A1A2 && !hasA1Data(product) ? '-' : product?.mpg || 0 | number:'.3-3' | dynamicDecimal: true}}
                                  </div>
                                  <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)" data-test="productMpgAfter">
                                      {{selectedDataSet == dataSetSetting.A1A2 && !hasA2Data(product)? '-' :  product?.mpgAfter || 0 | number:'.3-3' | dynamicDecimal: true}}
                                  </div>
                              </div>
                            </td>
                          </tr>
                        </thead>
                      </table>

                      <span *ngIf="product.comment" class="comment_container">
                        {{product.comment}}
                      </span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<!--End rest pages-->